import { Module } from "vuex-smart-module"

import UserAdminState from "./state"
import UserAdminMutations from "./mutations";
import UserAdminGetters from "./getters";
import UserAdminActions from "./actions"

export const userAdminModule = new Module({
    state: UserAdminState,
    getters: UserAdminGetters,
    mutations: UserAdminMutations,
    actions: UserAdminActions
})